<template>
  <div class="confirm-wrap">
    <my-header
        main-title="红字发票确认信息处理"
        :main-title-style="{color: '#337ab7'}"
        @back="emit('changePage', 'redInvoice_home')"
    />

    <div class="query-form-wrap">
      <el-form :model="queryParams"
               size="large"
               ref="formRef" :rules="rules" :inline="true" label-width="120px">

        <el-form-item label="购/销方选择"
                      prop="purBuyRole">
          <el-select
              v-model="queryParams.purBuyRole"
              style="width: 201px"
              disabled
              placeholder="请选择">
            <el-option label="我是购货方" value="我是购货方"/>
          </el-select>
        </el-form-item>

        <el-form-item label="确认单状态"
                      prop="confirmStatus">
          <el-select
              v-model="queryParams.confirmStatus"
              style="width: 201px"
              placeholder="请选择">
            <el-option label="购销双方确认" value="购销双方确认"/>
            <el-option label="无需确认" value="无需确认"/>
          </el-select>
        </el-form-item>

        <el-form-item
            label="对方纳税人名称"
            prop="otherSideName">
          <el-input
              v-model.trim="queryParams.otherSideName"
              style="width: 201px"
              clearable
              placeholder="请输入"/>
        </el-form-item>

        <el-form-item
            label="开票日期起" prop="hzMakeDateStart">
          <el-date-picker
              type="date"
              v-model="queryParams.hzMakeDateStart"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              :disabled-date="disableMakeStart"
              clearable
              placeholder="选择日期"
              style="width: 201px"
          />
        </el-form-item>

        <el-form-item label="开票日期止" prop="hzMakeDateEnd">
          <el-date-picker
              type="date"
              v-model="queryParams.hzMakeDateEnd"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              :disabled-date="disableMakeEnd"
              clearable
              placeholder="选择日期"
              style="width: 201px"
          />
        </el-form-item>

        <el-form-item label="开票状态"
                      prop="ticketStatus">
          <el-select
              disabled
              v-model="queryParams.ticketStatus"
              style="width: 201px"
              placeholder="请选择">
            <el-option label="未开具" value="未开具"/>
            <el-option label="已开具" value="已开具"/>
          </el-select>
        </el-form-item>

        <el-form-item label="录入方身份"
                      prop="signInRole">
          <el-select
              v-model="queryParams.signInRole"
              style="width: 201px"
              placeholder="请选择">
          </el-select>
        </el-form-item>

        <el-form-item size="default" style="padding-left: 35px;">
          <el-button @click="reset">重置</el-button>
          <el-button type="primary" @click="queryData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>


    <main class="main-box">
      <el-table
          ref="tableRef"
          :data="showTableList"
          class="red-confirm-table"
          style="margin-top: 10px;"
          border
      >

        <el-table-column label="购销身份" align="center" min-width="120">
          <template #default>
            <span>销售方</span>
          </template>
        </el-table-column>

        <el-table-column label="对方纳税人名称" align="center" prop="seller.name" min-width="200"/>

        <el-table-column label="纳税人识别号" align="center" prop="seller.taxRegistrationNo" min-width="160"/>

        <el-table-column label="对应蓝票全电发票号码" align="center" prop="item.allInvoiceNumber" min-width="180"/>

        <el-table-column label="红字通知单号" align="center" min-width="130"/>

        <el-table-column label="发票金额" prop="item.amount" align="center" min-width="130">
          <template #default="{row}">
            <span v-if="row.item?.amount != null">{{ row.item.amount.toFixed(2) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="发票税额" align="center" prop="item.taxAmount" min-width="130">
          <template #default="{row}">
            <span v-if="row.item?.taxAmount != null">{{ row.item.taxAmount.toFixed(2) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="开票状态" align="center" width="120">
          <template #default="{row}">
            <el-tag type="primary" v-if="row.kaijuStatus == 0">未开具</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作"
                         align="center"
                         fixed="right"
                         width="100">
          <template #default="{row}">
            <el-button
                size="small"
                type="primary" link
                @click="viewDetail(row)"
            >查看
            </el-button>
          </template>
        </el-table-column>

      </el-table>
    </main>

    <detail-dialog
        v-model:visible="detailVis"
        :current-row="currentRow"
        @confirm="onConfirm"
        @deny="onDeny"
    />

  </div>
</template>

<script setup>
import myHeader from "../cmp/myHeader.vue";
import dayjs from "dayjs";
import {ElMessage} from "element-plus";
import DetailDialog from "./detailDialog.vue";
import Big from "big.js";
import {convertBaseData, useSave39Qa} from "./initialDataHelp.js";
import {$emit} from "vue-happy-bus";


const rules = reactive({})
const queryParams = reactive({
  purBuyRole: '我是购货方',
  ticketStatus: '未开具',
})

const emit = defineEmits(['changePage'])

const showTableList = ref([])

const currentQa = inject('provideCurrentQa');

onMounted(() => {
})

function queryData() {
  if (currentQa.value.sonQueType != '39') { // 非39题，无法操作
    return
  }
  if (!queryParams.confirmStatus) {
    ElMessage.warning('请选择确认单状态')
    return
  }
  if (queryParams.confirmStatus == '无需确认') {
    showTableList.value = []
    return
  }
  const initialData = currentQa.value.initialAnswer && JSON.parse(currentQa.value.initialAnswer) || []

  // 分组后，显示在表格上
  showTableList.value = convertBaseData(initialData).filter(f => {
    let pass = true
    if (queryParams.otherSideName) {
      pass = pass && f.seller.name.indexOf(queryParams.otherSideName) > -1
    }
    return pass
  })
}

function reset() {
  queryParams.hzMakeDateEnd = undefined
  queryParams.hzMakeDateStart = undefined
  queryParams.otherSideName = undefined
  queryParams.confirmStatus = undefined
}

const detailVis = ref(false)
const currentRow = ref({})

function viewDetail(row) {
  currentRow.value = row
  detailVis.value = true
}

function disableMakeStart(date) {
  // 开始时间不能大于结束时间
  if (queryParams.hzMakeDateEnd && dayjs(date).isAfter(dayjs(queryParams.hzMakeDateEnd, 'YYYY-MM-DD').startOf('day'))) {
    return true
  }
  return false
}

function disableMakeEnd(date) {
  // 开始时间不能大于结束时间
  if (queryParams.hzMakeDateStart && dayjs(date).isBefore(dayjs(queryParams.hzMakeDateStart, 'YYYY-MM-DD').startOf('day'))) {
    return true
  }
  return false
}

function onConfirm() {
  currentSaveTag.value = 1
  $emit("exeSaveQa");
}

function onDeny() {
  currentSaveTag.value = 2
  $emit("exeSaveQa");
}

const {currentSaveTag} = useSave39Qa(currentQa, currentRow)


</script>


<style scoped lang="scss">
.confirm-wrap {
  display: flex;
  flex-direction: column;
  height: calc(100vh);

  .query-form-wrap {
    margin-top: 20px;
    flex-shrink: 0;
  }

  .main-box {
    margin: 0 20px 20px 20px;
    overflow: hidden;

    .red-confirm-table {
      height: 100% !important;
      max-height: 100% !important;
    }
  }
}
</style>
